import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D86C99FA-DFA7-4DD2-9EB8-CBB094BD1366
 * name plus-minus-variant
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-minus-variant.svg
 * tags
 * - Math 
 */
export const PlusMinusVariantIcon = createSvgIcon(<><path d="M3 7H6V4H8V7H11V9H8V12H6V9H3V7M13 15H21V17H13V15M16.04 3H18.35L7.96 21H5.65L16.04 3Z" /></>, 'PlusMinusVariantIcon');
export default PlusMinusVariantIcon